import * as Types from '../../../../types.generated';

import { api } from 'libs';
module.hot?.accept();
export type GetSalaryLogsQueryVariables = Types.Exact<{
  input: Types.SalaryLogsInput;
}>;


export type GetSalaryLogsQuery = { __typename?: 'Query', salaryLogs: Array<{ __typename?: 'LogResponse', id: string, createdAt: any, current?: string, previous?: string, field?: string, message: string, type: Types.LogType, employee: { __typename?: 'Employee', accountBank?: string, accountNumber?: string, accountType?: string, address?: string, areaId: string, arl?: string, bonus: any, celebrateBirthday: boolean, cellPhone?: string, city?: string, civilStatus?: string, compensationFund: string, computerBrand?: string, computerHardware: string, computerSerialNumber?: string, contractId: string, countryId: string, countryLocation: string, currency: string, custom: any, dateBirth?: any, dateEnd?: any, dateFamily?: any, dateStart: any, entranceExams: string, eps?: string, fees: any, firstName: string, gender: string, hasDoctorateDegree?: boolean, hasElementarySchool?: boolean, hasGraduateDegree?: boolean, hasHighSchool?: boolean, hasMastersDegree?: boolean, hasUniversity?: boolean, idNumber: string, idType: string, lastName: string, middleName: string, pensionFund?: string, personalEmail?: string, phone?: string, positionId: string, salary: any, secondLastName: string, severanceFund: string, state?: string, stateBirth?: string, subAreaId: string, whereStudy?: string, withdrawalReason: string, position: { __typename?: 'Position', name: any }, contract: { __typename?: 'Contract', name: any }, area: { __typename?: 'Area', name: string }, subArea: { __typename?: 'SubArea', name: string }, children?: Array<{ __typename?: 'Child', birthDate: string, fullName: string, gender: string }>, educationRecords?: Array<{ __typename?: 'EducationRecord', level: string, status: string, studyName: string, degreeTitle?: string }> } }> };

export type GetRoleLogsQueryVariables = Types.Exact<{
  input: Types.RoleChangeLogsInput;
}>;


export type GetRoleLogsQuery = { __typename?: 'Query', roleChangeLogs: Array<{ __typename?: 'LogResponse', id: string, createdAt: any, current?: string, previous?: string, field?: string, message: string, type: Types.LogType, employee: { __typename?: 'Employee', accountBank?: string, accountNumber?: string, accountType?: string, address?: string, areaId: string, arl?: string, bonus: any, celebrateBirthday: boolean, cellPhone?: string, city?: string, civilStatus?: string, compensationFund: string, computerBrand?: string, computerHardware: string, computerSerialNumber?: string, contractId: string, countryId: string, countryLocation: string, currency: string, custom: any, dateBirth?: any, dateEnd?: any, dateFamily?: any, dateStart: any, entranceExams: string, eps?: string, fees: any, firstName: string, gender: string, hasDoctorateDegree?: boolean, hasElementarySchool?: boolean, hasGraduateDegree?: boolean, hasHighSchool?: boolean, hasMastersDegree?: boolean, hasUniversity?: boolean, idNumber: string, idType: string, lastName: string, middleName: string, pensionFund?: string, personalEmail?: string, phone?: string, positionId: string, salary: any, secondLastName: string, severanceFund: string, state?: string, stateBirth?: string, subAreaId: string, whereStudy?: string, withdrawalReason: string, contract: { __typename?: 'Contract', name: any }, children?: Array<{ __typename?: 'Child', birthDate: string, fullName: string, gender: string }>, educationRecords?: Array<{ __typename?: 'EducationRecord', level: string, status: string, studyName: string, degreeTitle?: string }>, position: { __typename?: 'Position', name: any }, area: { __typename?: 'Area', name: string }, subArea: { __typename?: 'SubArea', name: string } } }> };


export const GetSalaryLogsDocument = `
    query GetSalaryLogs($input: SalaryLogsInput!) {
  salaryLogs(input: $input) {
    id
    createdAt
    current
    previous
    field
    message
    type
    employee {
      accountBank
      accountNumber
      accountType
      address
      areaId
      arl
      bonus
      celebrateBirthday
      cellPhone
      city
      civilStatus
      compensationFund
      computerBrand
      computerHardware
      computerSerialNumber
      contractId
      countryId
      countryLocation
      currency
      custom
      dateBirth
      dateEnd
      dateFamily
      dateStart
      entranceExams
      eps
      fees
      firstName
      gender
      hasDoctorateDegree
      hasElementarySchool
      hasGraduateDegree
      hasHighSchool
      hasMastersDegree
      hasUniversity
      idNumber
      idType
      lastName
      middleName
      pensionFund
      personalEmail
      phone
      positionId
      salary
      secondLastName
      severanceFund
      state
      stateBirth
      subAreaId
      whereStudy
      withdrawalReason
      position {
        name
      }
      contract {
        name
      }
      area {
        name
      }
      subArea {
        name
      }
      children {
        birthDate
        fullName
        gender
      }
      educationRecords {
        level
        status
        studyName
        degreeTitle
      }
    }
  }
}
    `;
export const GetRoleLogsDocument = `
    query GetRoleLogs($input: RoleChangeLogsInput!) {
  roleChangeLogs(input: $input) {
    id
    createdAt
    current
    previous
    field
    message
    type
    employee {
      accountBank
      accountNumber
      accountType
      address
      areaId
      arl
      bonus
      celebrateBirthday
      cellPhone
      city
      civilStatus
      compensationFund
      computerBrand
      computerHardware
      computerSerialNumber
      contractId
      contract {
        name
      }
      children {
        birthDate
        fullName
        gender
      }
      educationRecords {
        level
        status
        studyName
        degreeTitle
      }
      countryId
      countryLocation
      currency
      custom
      dateBirth
      dateEnd
      dateFamily
      dateStart
      entranceExams
      eps
      fees
      firstName
      gender
      hasDoctorateDegree
      hasElementarySchool
      hasGraduateDegree
      hasHighSchool
      hasMastersDegree
      hasUniversity
      idNumber
      idType
      lastName
      middleName
      pensionFund
      personalEmail
      phone
      positionId
      position {
        name
      }
      salary
      secondLastName
      severanceFund
      state
      stateBirth
      subAreaId
      whereStudy
      withdrawalReason
      area {
        name
      }
      subArea {
        name
      }
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (build) => ({
    GetSalaryLogs: build.query<GetSalaryLogsQuery, GetSalaryLogsQueryVariables>({
      query: (variables) => ({ document: GetSalaryLogsDocument, variables })
    }),
    GetRoleLogs: build.query<GetRoleLogsQuery, GetRoleLogsQueryVariables>({
      query: (variables) => ({ document: GetRoleLogsDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };


